/**
 * Creates an HTML element of the specified tag with optional attributes and class name.
 *
 * @param tag - The HTML tag name of the element to create.
 * @param attributes - Optional attributes to assign to the element.
 * @param className - Optional class name to assign to the element.
 * @returns The created HTML element.
 */
export function createElement<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attributes: Partial<HTMLElementTagNameMap[K]> = {},
  className: string = ''
): HTMLElementTagNameMap[K] {
  const element = document.createElement(tag);

  Object.assign(element, attributes);

  if (className) element.className = className;
  return element;
}
